import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const ViewExpenseSapMigrationButton = ({ handleView, expenseSapMigration, index }) => (
  <Button
    color="info"
    outline
    className="mr-3"
    onClick={() => handleView(expenseSapMigration, index)}
    title="Ver detalle"
  >
    <i className="fa fa-eye" />
  </Button>
);

ViewExpenseSapMigrationButton.propTypes = {
  handleView: PropTypes.func.isRequired,
  expenseSapMigration: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
};

export default ViewExpenseSapMigrationButton;